import Vue from "vue";


export function pageAllWorkflowTypeApi(params, success, complete) {
    let url = "/admin/web/workflowType/pageAllWorkflowType";
    Vue.prototype.alexPost(url, params, success, null, complete);
}

export function listAllWorkflowTypeApi(params, success) {
    let url = "/admin/web/workflowType/listAllWorkflowType";
    Vue.prototype.alexPost(url, params, success);
}


export function insertWorkflowTypeApi(params, success) {
    let url = "/admin/web/workflowType/insertWorkflowType";
    Vue.prototype.alexPost(url, params, success);
}

export function updateWorkflowTypeApi(params, success) {
    let url = "/admin/web/workflowType/updateWorkflowType";
    Vue.prototype.alexPost(url, params, success);
}


export function deleteWorkflowTypeApi(params, success) {
    let url = "/admin/web/workflowType/deleteWorkflowType";
    Vue.prototype.alexPost(url, params, success);
}


export function workflowTypeConfigApi(params, success) {
    let url = "/admin/web/workflowType/workflowTypeConfig";
    Vue.prototype.alexPost(url, params, success);
}






